<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Lab Instrument Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase">Info</span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Instrument" :label-cols="3">
                <div>
                  <multiselect
                    v-model="form_data.instrument_id"
                    :value="form_data.instrument_id"
                    :options="instrument_options"
                    :multiple="false"
                    track-by="text"
                    label="text"
                  />
                </div>
              </b-form-group>
              <b-form-group label="Identifier" :label-cols="3">
                <b-form-input
                  type="text"
                  v-model.trim="form_data.identifier"
                  placeholder="Identifier"
                />
              </b-form-group>
              <b-form-group label="Name" :label-cols="3">
                <b-form-input
                  type="text"
                  v-model.trim="form_data.name"
                  placeholder="Name"
                />
              </b-form-group>
              <b-form-group label="Priority" :label-cols="3">
                <b-form-radio-group
                  v-model="form_data.priority"
                  name="priority"
                >
                  <b-form-radio
                    v-for="option in priority_options"
                    :key="option.key"
                    :value="option.key"
                    @change="updatePriority"
                  >
                    {{ option.label }}
                  </b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-group label="Sample Capacity" :label-cols="3">
                <b-form-input
                  type="number"
                  v-model.number="form_data.capacity"
                  placeholder="Capacity"
                />
              </b-form-group>
              <b-form-group label="Daily Capacity" :label-cols="3">
                <b-form-input
                  type="number"
                  v-model.number="form_data.daily_capacity"
                  placeholder="Daily Capacity"
                />
              </b-form-group>
              <b-form-group label="Runtime" :label-cols="3">
                <b-row>
                  <b-col class="pr-0">
                    <b-form-input
                      type="number"
                      v-model.number="form_data.runtime"
                      placeholder="Runtime"
                    />
                  </b-col>
                  <b-col>
                    <b-form-select
                      v-model="form_data.runtime_display"
                      :options="runtime_options"
                    />
                  </b-col>
                </b-row>
              </b-form-group>
              <b-form-group label="Equipment Number" :label-cols="3">
                <b-form-input
                  type="number"
                  v-model="form_data.equipment_number"
                  placeholder="Equipment Number"
                />
              </b-form-group>
              <b-form-group label="Serial Number" :label-cols="3">
                <b-form-input
                  type="number"
                  v-model="form_data.serial_number"
                  placeholder="Serial Number"
                />
              </b-form-group>
              <b-form-group label="Model Number" :label-cols="3">
                <b-form-input
                  type="text"
                  v-model.trim="form_data.model_number"
                  placeholder="Model Number"
                />
              </b-form-group>
              <b-form-group label="Location" :label-cols="3">
                <b-form-input
                  type="text"
                  v-model="form_data.location"
                  placeholder="Location"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="3">
                <b-form-textarea
                  v-model.trim="form_data.description"
                  placeholder="Description"
                />
              </b-form-group>
              <b-form-group label="Multi result?" :label-cols="3">
                <b-form-checkbox
                  v-model="form_data.multi_result"
                  :value="1"
                  :unchecked-value="0"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import InstrumentModel from "@/models/lab/InstrumentModel";
import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "InstrumentInstanceForm",
  components: {
    Multiselect,
  },
  props: {
    instrument_instance: {
      type: Object,
      default: () => new InstrumentInstanceModel(),
    },
  },
  data() {
    return {
      loading: true,
      form_data: {
        backup: 0,
        capacity: null,
        daily_capacity: 500,
        description: null,
        equipment_number: null,
        identifier: null,
        instrument_id: null,
        laboratory_id: this.$store.getters.getLaboratoryContext.id,
        location: null,
        model_number: null,
        multi_result: 0,
        name: null,
        primary: 0,
        serial_number: null,
        runtime: 0,
        runtime_display: null,
        priority: "default",
      },
      instrument_collection: null,
      instrument_options: null,
      runtime_options: null,
      priority_options: {
        default: {
          key: "default",
          label: "Default",
          primary: 0,
          backup: 0,
        },
        primary: {
          key: "primary",
          label: "Primary",
          primary: 1,
          backup: 0,
        },
        backup: {
          key: "backup",
          label: "Backup",
          primary: 0,
          backup: 1,
        },
      },
    };
  },
  methods: {
    async getInstruments() {
      this.instrument_collection = await getCollection({
        collection_type: "instrument",
        sort: [
          {
            logic: "sortAddAsc",
            field: "name",
          },
        ],
        limit: "all",
        message: this.$bvToast,
      });

      this.instrument_options = this.instrument_collection.models.map(
        ({ id, name }) => {
          return {
            value: id,
            text: name,
          };
        }
      );
    },
    setDefaultFormData() {
      const { primary, backup, instrument_id } = this.instrument_instance;

      this.form_data = {
        ...this.form_data,
        ...this.instrument_instance.cloneAttributes(true, true),
        instrument_id: this.instrument_options.find(
          ({ value }) => value === instrument_id
        ),
        priority: primary ? "primary" : backup ? "backup" : "default",
      };
    },
    async init() {
      await this.getInstruments();

      const runtime_options = InstrumentModel.formatRuntimeOptions();

      this.runtime_options = [
        {
          text: "Not selected",
          value: null,
        },
        ...Object.keys(runtime_options).map((key) => {
          return {
            text: runtime_options[key],
            value: key,
          };
        }),
      ];
      this.instrument_instance.id && this.setDefaultFormData();
      this.loading = false;
    },
    updatePriority(e) {
      const { backup, key, primary } = this.priority_options[e];

      this.form_data = {
        ...this.form_data,
        priority: key,
        backup,
        primary,
      };
    },
    submitForm() {
      const payload = {
        ...this.form_data,
        instrument_id:
          this.form_data.instrument_id && this.form_data.instrument_id.value,
      };

      this.$emit("submit", payload);
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
